import * as types from "../ActionTypes/banners";

export function fetchActiveBannerResolved(payload) {
  return {
    type: types.FETCH_ACTIVE_BANNER_RESOLVED,
    payload
  };
}
